import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/authContext";
import { message } from "antd";
import { useSelector } from "react-redux";

const LockRedirect = () => {
  const { dashboardData } = useSelector((state) => state.dashboards);
  const { isLock } = dashboardData || {};
  const location = useLocation();

  if (isLock && location.pathname !== "/signin-kiosk") {
    message.error("Locked all module, you can't access any module. ")
    return <Navigate to="/signin-kiosk" replace />;
  }

  return <Outlet />;
};

export default LockRedirect;
